/* PTK: Variant tooltip behavior
   - Desktop (hover:fine): hover/focus only, clicking does NOT latch tooltip open
   - Mobile (hover:none or pointer:coarse): tap toggles open/close
*/
(() => {
  const SELECTOR = '[data-ptk-tooltip]';
  const isTouchLike = () =>
    window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function closeAll(exceptBtn) {
    document.querySelectorAll(`${SELECTOR}[aria-expanded="true"]`).forEach((btn) => {
      if (exceptBtn && btn === exceptBtn) return;
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR);

    // If click wasn't on a tooltip button, close any open (mobile) tooltips
    if (!btn) {
      closeAll();
      return;
    }

    // On desktop/hover devices: do not toggle open on click.
    // Ensure it's not "latched" open if someone clicked it.
    if (!isTouchLike()) {
      btn.setAttribute('aria-expanded', 'false');
      return;
    }

    // On touch-like devices: toggle open/close and close others
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    closeAll(btn);
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();
